export default __webpack_public_path__ + "static/media/INTERVIEW.bdd93d60.pdf";